'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Svg;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ = require('./');

var svgImages = _interopRequireWildcard(_);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getSvgImage = function getSvgImage(image) {
  return svgImages[image]();
};

function Svg(props) {
  var className = props.className,
      image = props.image;


  var svgContent = { __html: getSvgImage(image) };

  if (svgContent) {
    return _react2.default.createElement('div', { className: className, dangerouslySetInnerHTML: svgContent });
  }

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'b',
      null,
      'Invalid svg image name'
    )
  );
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/Svg/Svg.js
// module id = 1133
// module chunks = 0